import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Floating "back to top" button for long management pages - appears once the user has
// scrolled down, lets them jump back to the top without hunting for the browser's own
// scrollbar. Brand blue to match the primary action color used across the app.
export const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      data-testid="scroll-to-top-button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
      className="fixed bottom-6 right-6 z-40 flex items-center justify-center h-11 w-11 rounded-full bg-blue-600 text-white shadow-lg hover:bg-blue-700 active:scale-95 transition-all"
    >
      <ArrowUp size={20} />
    </button>
  );
};
